module.exports = {
	"ha": "viha",
	"id": 1.7,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in Island Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019",
					"2019",
					"2019",
					"2019",
					"2020",
					"2020",
					"2020",
					"2020",
					"2021",
					"2021",
					"2021",
					"2021",
					"2022",
					"2022"
				],
				"tickPositions": [
					0,
					2,
					6,
					10,
					14,
					18
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1.054,
					1.057,
					1.151,
					1.207,
					1.205,
					1.364,
					1.379,
					1.382,
					1.466,
					1.344,
					1.247,
					0.776,
					0.885,
					1.109,
					1.153,
					1.105,
					1.08,
					1.06,
					1.059,
					{
						"y": 1.081,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.187,
					0.234,
					0.244,
					0.255,
					0.247,
					0.244,
					0.254,
					0.256,
					0.249,
					0.261,
					0.223,
					0.115,
					0.186,
					0.224,
					0.203,
					0.192,
					0.204,
					0.212,
					0.23,
					{
						"y": 0.226,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.721,
					1.714,
					1.929,
					1.827,
					1.713,
					1.936,
					2.016,
					1.912,
					1.864,
					1.901,
					1.679,
					1.078,
					1.4,
					1.422,
					1.499,
					1.469,
					1.346,
					1.325,
					1.304,
					{
						"y": 1.478,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_1_7.json
// module id = 323
// module chunks = 0